import React from "react";
import { Box, ClassNameMap, Grid, Typography } from "@mui/material";
import { RangeType } from "../../store/cardPrompt/types";
import pageStyles from "./../../pages/pageStyles";
import SectionWrapper from "../pageSections/SectionWrapper";

interface ItemDetailBinRange {
  binRange: RangeType[];
  styles: ClassNameMap;
}
const ItemDetailBinRanges = ({ binRange, styles }: ItemDetailBinRange) => {
  const classes = pageStyles();

  return (
    <SectionWrapper isChild isWhiteBG title="Bin Ranges">
      <Grid item xs={12}>
        {binRange.map((data, index) => (
          <Grid key={index} item xs={12} className={classes.additionalDataBox}>
            <Box>
              <Box mb={1}>
                <Typography display="block" className={styles.textTitle}>
                  Length: {data.Length}
                </Typography>
              </Box>
              <Box mb={1} className={classes.truncate}>
                <Typography display="block" className={styles.textTitle}>
                  Account: {data.Account.join(", ")}
                </Typography>
              </Box>
              <Box mb={1} className={classes.truncate}>
                <Typography display="block" className={styles.textTitle}>
                  From: {data.From}
                </Typography>
              </Box>
              <Box mb={1} className={classes.truncate}>
                <Typography display="block" className={styles.textTitle}>
                  To: {data.To}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </SectionWrapper>
  );
};

export default ItemDetailBinRanges;
